<h1 class="text-center text-primary">Order History</h1>
<br/>

<div class="row">
  <div class="col-2">
    <label for="brand">Select Order</label>
  </div>
  <div class="col-6">
    <ng-select [items]="orders$ | async"
      autofocus
      bindValue="orderReference"
      [(ngModel)]="selectedOrderReference">
      <ng-template ng-label-tmp let-item="item">
        <span >{{ 'Order: ' + item.orderReference + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date: ' + (item.orderDate | date:'mediumDate') }}</span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
        <span >{{ 'Order: ' + item.orderReference + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date: ' + (item.orderDate | date:'mediumDate') }}</span>
      </ng-template>
    </ng-select>

  </div>
  <div class="col-2">
    <form [formGroup]="searchForm" (ngSubmit)="searchForm.valid && search()" autocomplete="off">
      <div class="form-group text-center">
        <button [disabled]='!searchForm.valid' class="btn btn-primary lg" type="submit">Search</button>
      </div>
    </form>


  </div>
</div>

@if (toonDetailsOrder) {
  <div class="container">
    <div class="alert alert-dismissible alert-primary">
      <div class="row">
        <div class="col-3"><strong><span class="notranslate">Order:</span></strong></div>
        <div class="col-2">{{selectedOrderReference}}</div>
      </div>
      <div class="row">
        <div class="col-3"><strong>Date:</strong></div>
        <div class="col-2">{{selectedOrder?.orderDate | date:'mediumDate'}}</div>
      </div>
      <div class="row">
        <div class="col-3"><strong>Customer Reference:</strong></div>
        <div class="col-2">{{selectedOrder?.customerReference}}</div>
      </div>
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Product Code</th>
          <th scope="col">Brand</th>
          <th scope="col">Description</th>
          <th scope="col" class="text-right">Dealer Price</th>
          <th scope="col" class="text-right">Your Price</th>
          <th scope="col" class="text-right">Quantity</th>
          <th scope="col" class="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        @for (line of orderlines$ | async; track line; let i = $index) {
          <tr >
            <td>{{line.xref}}</td>
            <td><img src="../../../assets/{{line.merk.toLowerCase()}}.png" alt="{{line.merk}}" height="20"  ></td>
            <td>{{line.omschrijving}}</td>
            <td class="text-right">{{line.brutoprijs}}</td>
            <td class="text-right">{{line.verkoopprijs.toFixed(2)}}</td>
            <td class="text-right">{{line.aantal}}</td>
            <td class="text-right">{{(line.verkoopprijs * line.aantal).toFixed(2)}}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col" class="text-right">TOTAL</th>
          <th scope="col" class="text-right">{{total.toFixed(2)}}</th>
        </tr>
      </tfoot>
    </table>
  </div>
}

@if (toonNoOrder) {
  <div class="container">
    <div class="alert alert-dismissible alert-warning">
      <p class="mb-0">No order selected.</p>
    </div>
  </div>
}






